import 'PublicPath';

import createStore from 'store/main';
import renderReact from 'utils/renderReact';

import App from './App';

// eslint-disable-next-line import/no-default-export
export default renderReact('main', App, createStore);
